import {

  Checkbox,
  KoDate,
  KoForm,
  KoFormBuilder,
  KoText,
  KoUserSelect
} from 'packages';


import styles from './curd.module.scss';
import OptionsList from './optionsList';
import { useEffect, useState } from 'react';
import { PollAPI } from './poll.service';


function PollCurd({ form,getPolls,
  handleFinish, initialValues }) {
  const [users, setUsers] = useState([]);
  const [groups, setGroups] = useState([]);


  useEffect(() => {
    let isMounted = true;
  
    const fetchData = async() => {
      try {
        const [userData, groupData] = await Promise.all([
          PollAPI.getUsers(),
          PollAPI.getGroups()
        ]);
        if (isMounted) {
          setUsers(userData['users']);
          setGroups(groupData['groups']);
        }
      } catch (error) {
        console.error("Error fetching users or groups:", error);
      }
    };
  
    fetchData();
  
    return () => {
      isMounted = false;
    };
  }, []);

  const handleDownloadCSV = () => {
    const header = "value\n";
    const rows = ["Option 1", "Option 2"];
    const csvContent = header + rows.join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "sample-options.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const Date = ({ value, onChange }) => {

    return (
      <KoDate
        value={value}
        format={'DD-MMM-YYYY'}
        daysAgo={0}
        onChange={v => onChange(v)}
      />
    );
  };

  const SUMMARYSECTION = {
    columns: 6,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'title', placeholder: 'Enter poll title', label: 'Title', colSpan: 6,
        rules: [
          {
            required: true,
            message: `Please enter title.`
          }
        ]
      },
      {
        key: 'label1',
        colSpan: 6,
        render() {
          return (
            <fieldset>
              <legend>ADD POLL OPTIONS  <KoText className={styles.sample} onClick={handleDownloadCSV} text="Download Sample CSV" /></legend>
            </fieldset>
          );
        }
      },
      {
        key: 'answerOptions',
        placeholder: 'Enter options',
        label:'',
        colSpan: 6,
        widget: OptionsList
      }

    ]
  };

  const Watchers = ({ value, onChange }) =>
    <KoUserSelect mode='multiple' value={value} onChange={v => onChange(v)} users={users} placeholder='Select participants' />;

  const Groups = ({ value, onChange }) =>
    <KoUserSelect mode='multiple' value={value} onChange={v => onChange(v)} users={groups} placeholder='Select groups' />;
  
  const CheckBoxHide = ({ value, onChange }) =>
    <Checkbox checked={value} onChange={v => onChange(v?.target?.checked)}>{`Hide 'Other' Option Results`}</Checkbox>;
  
  const CheckBoxAllow = ({ value, onChange }) =>
    <Checkbox checked={value} onChange={v => onChange(v?.target?.checked)}>Allow Multiple Choices</Checkbox>;
  
  const CheckBoxName = ({ value, onChange }) =>
    <Checkbox checked={value} onChange={v => onChange(v?.target?.checked)}>Require Voter Names</Checkbox>;

  
  const BASICMETADATA = {
    columns: 6,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'label1',
        colSpan: 6,
        render() {
          return (
            <fieldset>
              <legend>POLL ADMINS</legend>
            </fieldset>
          );
        }
      },
      {
        key: 'pollAdmins', label: 'Poll Admin', colSpan: 6,
        widget: Watchers
      },
     
      {
        key: 'label1',
        colSpan: 6,
        render() {
          return (
            <fieldset>
              <legend>PARTICIPANTS</legend>
            </fieldset>
          );
        }
      },
      {
        key: 'users', label: 'Participants', colSpan: 3,
        widget: Watchers,
        rules: [
          {
            required: true,
            message: 'Please select participants.'
          }
        ]
      },
      {
        key: 'groups', label: 'Groups', colSpan: 3,
        widget: Groups
       
      },
      {
        key: 'label3',
        colSpan: 6,
        render() {
          return (
            <fieldset>
              <legend>DATE & CALENDAR</legend>
            </fieldset>
          );
        }
      },

      {
        key: 'startDate', placeholder: 'Enter Start Date', label: 'Start Date',
        colSpan: 3, widget: Date, rules:  [
          {
            required: true,
            message: 'Please select start date.'
          }
        ]
      },
      {
        key: 'endDate', placeholder: 'Enter End Date', label: 'End Date', colSpan: 3, widget: Date,
        rules: [
          {
            required: true,
            message: 'Please select end date.'
          }
        ]
      },
      {
        key: 'label1s',
        colSpan: 64,
        render() {
          return (
            <fieldset>
              <legend>SETTINGS</legend>
            </fieldset>
          );
        }
      },
      { key: 'settings.hideOtherOptionResult', colSpan: 4, widget:CheckBoxHide},
      {
        key: 'settings.isMultipleChoice', colSpan: 4, widget: CheckBoxAllow
      },
      { key: 'settings.requireVoterNames', colSpan: 4, widget: CheckBoxName }
    ]
  };


  const handleSubmit = (values) => {
    values['answerOptions'] = values?.options;
    handleFinish(values);
  };

  return (
    <div className={`${styles.ticketWrapper} 'tabContnetTicket'`}>
      <div className={`${styles.wrapper}`}>
        <KoForm form={form} layout="vertical"
          onFinish={handleSubmit} onSubmit={handleSubmit}>
          <div className={styles.leftForm}>
            <KoFormBuilder form={form} meta={SUMMARYSECTION} />
          </div>
          <div className={styles.rightForm}>
            <KoFormBuilder form={form} meta={BASICMETADATA} />
          </div>
        </KoForm>
      </div>
    </div>
  );
};

export default PollCurd;